export default "__VITE_ASSET__bsSD71_6uK7QSBiaRH8tIg__"